module.exports = __webpack_public_path__ + "root-c2082cbd/3eb8c938acb9fa661bd09da22de135dc.svg";